import useBizNode from '../../useBizNode.mjs'
import readProject from '../readProject.mjs'

export default (pkid, type) => {
    const BizNode = useBizNode()

    return async () => {
        const initData = await BizNode[type].readMap({pkid})
        const {prjId, sVer} = initData.data
        const project = await readProject(prjId, sVer)
        Object.assign(initData.data, project)
        return initData
    }
}
